export default "/JMMMU/art_psychology.ace0c789-941c65.png";